module.exports = __webpack_public_path__ + "static/media/Panama.99700dbb.png";